<div class="card card-home mt-2">
    <div class="card-body text-center">
        <img [src]="imageFullPath" alt="Avatar" style="width:64px">
        <div> {{cardTitle}}
        <span *ngIf="optionDetail"> ({{optionDetail}})</span>
      </div>
    </div>
</div>
